export default "__VITE_ASSET__53300635__"